import ArrowBack from 'assets/icons/ios/ios-arrow-back.svg'

ArrowBack.displayName = 'ArrowBack'
export default ArrowBack
